var map = {
	"./1.jpg": 5183,
	"./2.jpg": 1568,
	"./3.jpg": 2701,
	"./4.jpg": 7942,
	"./404error.jpg": 5714,
	"./BSI_Co-lab.png": 2485,
	"./BSI_Co-lab_hover.png": 7574,
	"./EmptyFolder.png": 3497,
	"./Inbox.png": 6229,
	"./Inbox_hover.png": 6729,
	"./Meetings.png": 6442,
	"./Meetings_hover.png": 897,
	"./NoDataPage.png": 6872,
	"./Profile.png": 1161,
	"./Profile_hover.png": 5354,
	"./Vector.png": 9893,
	"./Wallet.png": 2127,
	"./add_team_member.png": 7098,
	"./add_team_member_active.png": 5561,
	"./american-express.svg": 471,
	"./analytics.svg": 1254,
	"./avatar-1.png": 57,
	"./avi.png": 7055,
	"./blueCrown.png": 4747,
	"./bluesky.png": 865,
	"./bsi_drive.png": 1753,
	"./bsi_drive_hover.png": 8250,
	"./chat-icon.jpg": 546,
	"./chatgtp.png": 3675,
	"./collaps-icon.png": 450,
	"./companyLogo.jfif": 5965,
	"./crown.png": 9195,
	"./css.png": 7907,
	"./csv.png": 3406,
	"./dashboard_icon.png": 6244,
	"./dashboard_icon_hover.png": 1075,
	"./default_user.jpg": 3867,
	"./diamond.png": 8022,
	"./discover-card.png": 7106,
	"./doc.png": 4708,
	"./doc_icon.png": 3682,
	"./docxIcon.png": 9110,
	"./download-icon.avif": 1658,
	"./downloadIcon.png": 8727,
	"./download_icon.png": 1542,
	"./emoji-icons.png": 1937,
	"./empty_bsi_co_lab.png": 6157,
	"./exe.png": 8222,
	"./file.png": 666,
	"./form-banner-img.jpg": 9301,
	"./gif.png": 7104,
	"./gifIcon.jfif": 3834,
	"./gifIcon.png": 3887,
	"./headquarter_icon.png": 2846,
	"./headquarters.png": 7625,
	"./home_banner.jpg": 8056,
	"./html.png": 6131,
	"./image 166-1.png": 4354,
	"./image-icon.webp": 231,
	"./image1.png": 1504,
	"./image2.png": 1675,
	"./image3.png": 1170,
	"./image4.png": 2893,
	"./image5.png": 5412,
	"./image6.png": 6879,
	"./image7.png": 5334,
	"./image8.png": 3201,
	"./image9.png": 2072,
	"./image_153.png": 9917,
	"./image_154.png": 5058,
	"./image_155.png": 9883,
	"./image_172.png": 6254,
	"./image_53.png": 4366,
	"./images.jfif": 5283,
	"./img.png": 439,
	"./industries.png": 4030,
	"./industry_icon.png": 3848,
	"./investment_icon.svg": 7131,
	"./investment_icon_active.svg": 5932,
	"./jpeg.png": 8066,
	"./jpg.png": 2635,
	"./json-file.png": 2655,
	"./kanban1.png": 92,
	"./kanban2.png": 2743,
	"./kanban3.png": 254,
	"./kanban4.png": 3345,
	"./kanban5.png": 3128,
	"./kanban6.png": 9987,
	"./kanban7.png": 2234,
	"./logo.avif": 1663,
	"./manage-team-member.png": 772,
	"./manage_team_member.jpg": 8816,
	"./manage_team_member_icon.webp": 9042,
	"./mastercard.svg": 9722,
	"./media1.jpg": 2921,
	"./media2.jpg": 1422,
	"./menu_left_arrow.svg": 5639,
	"./menu_right_arrow.svg": 1718,
	"./mov.png": 240,
	"./mp3.png": 264,
	"./mp4.png": 9255,
	"./my_solutions.png": 9531,
	"./my_solutions_hover.png": 8364,
	"./noDataFound.svg": 8441,
	"./noDataImage.gif": 2477,
	"./no_chat_selected.png": 5706,
	"./no_chat_selected.svg": 9648,
	"./no_chat_selected_processed.png": 3563,
	"./no_document.png": 6037,
	"./no_inbox.png": 4780,
	"./no_meetings.png": 8120,
	"./no_messages.png": 1334,
	"./no_milestone.png": 5150,
	"./no_project.png": 3623,
	"./no_project_screen.png": 8476,
	"./no_project_screen.svg": 6008,
	"./no_responses.png": 4732,
	"./no_result_found.png": 1412,
	"./no_team_member.webp": 5654,
	"./no_user.png": 4007,
	"./ogg.png": 5119,
	"./overview_icon.png": 9297,
	"./overview_icon.svg": 9317,
	"./pdf.png": 9348,
	"./pdfImage.webp": 5925,
	"./pdf_icon.png": 626,
	"./pdf_img.png": 660,
	"./png.png": 8031,
	"./portfolio_icon.png": 324,
	"./portfolio_icon_hover.png": 739,
	"./profile_img.png": 3837,
	"./progress_graph_icon.png": 758,
	"./project.png": 5073,
	"./project_hover.png": 1842,
	"./selected_chart_icon.svg": 9484,
	"./selected_overview_icon.svg": 651,
	"./settings.svg": 5189,
	"./solutionLogo.jfif": 4653,
	"./solution_icon.svg": 1869,
	"./solution_icon1.jpg": 8748,
	"./solution_icon_active.svg": 838,
	"./solution_logo.png": 6671,
	"./success-icon.png": 6337,
	"./svg.png": 768,
	"./txt.png": 1001,
	"./unselected_chart_icon.svg": 8783,
	"./unselected_overview_icon.svg": 2818,
	"./upgrade-icon.svg": 9632,
	"./upgrade.png": 558,
	"./upgradeCrown.png": 8877,
	"./use-cases.png": 6959,
	"./usecase_icon.png": 6299,
	"./verify-check-icon.png": 4032,
	"./video_icon.png": 1975,
	"./visa.svg": 1997,
	"./wav.png": 7784,
	"./we_teams_logo.png": 8037,
	"./whiteCrown.png": 3840,
	"./whiteUpgradeCrown.png": 216,
	"./wmv.png": 172,
	"./xls.png": 5081,
	"./xlsx.png": 8197,
	"./xml.png": 577,
	"./zip.png": 6711
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;